/** Clockwise around the felt; south is the default bottom slot. */
export const SEAT_ORDER = ['north', 'east', 'south', 'west'];

export const SEAT_LABELS = {
  north: 'North',
  south: 'South',
  east: 'East',
  west: 'West',
};

export const TEAM_SEATS = {
  ns: ['north', 'south'],
  ew: ['east', 'west'],
};

/** Game-over / results: username for humans, "North Bot" style for bots. */
export function seatOccupantLabel(seat, occupant) {
  if (!occupant) return SEAT_LABELS[seat] || seat;
  if (occupant.type === 'site_bot' || occupant.type === 'external_bot') {
    return `${SEAT_LABELS[seat]} Bot`;
  }
  return occupant.username || SEAT_LABELS[seat] || seat;
}

export function teamOccupantLabel(seats, seatList) {
  return seatList.map((s) => seatOccupantLabel(s, seats?.[s])).join(' / ');
}

const SOUTH_INDEX = SEAT_ORDER.indexOf('south');

/** Map absolute seat to visual CSS slot so viewer's seat renders at the bottom. */
export function visualSeatClass(absoluteSeat, viewerSeat) {
  if (!viewerSeat) return absoluteSeat;
  const viewerIdx = SEAT_ORDER.indexOf(viewerSeat);
  const seatIdx = SEAT_ORDER.indexOf(absoluteSeat);
  if (viewerIdx < 0 || seatIdx < 0) return absoluteSeat;
  const visualIdx = (seatIdx - viewerIdx + SOUTH_INDEX + SEAT_ORDER.length) % SEAT_ORDER.length;
  return SEAT_ORDER[visualIdx];
}

/** Degrees so avatar top faces away from table center (for top-down seat art). */
export function avatarRotationForVisualSeat(visualSeat) {
  const map = { north: 0, east: 90, south: 180, west: 270 };
  return map[visualSeat] ?? 0;
}

/** Hand strip sits toward the outer edge of the felt for this visual seat. */
export function handBeforeAvatar(visualSeat) {
  return visualSeat === 'north' || visualSeat === 'west';
}